import { collectionEngineV1 } from '../apis.js';
const companiesAPI = collectionEngineV1('/company-search');
export const search = (q) => companiesAPI('GET', `/?q=${encodeURIComponent(q)}`);
//# sourceMappingURL=companies.js.map